import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import AdminLayout from "../../components/layout/AdminLayout/AdminLayout";
import eventService from "../../services/event/eventService";
import sweetAlert from "../../utils/sweetAlert";
import { toast } from "react-toastify";

import "./Event.css";

export default function EventList() {

    const [events, setEvents] = useState([]);

    const [loading, setLoading] = useState(true);

    const [page, setPage] = useState(1);

    const [pageSize] = useState(10);

    const [search, setSearch] = useState("");

    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        loadEvent();
    }, [page, search]);

    const loadEvent = async () => {

        try {

            setLoading(true);

            const response = await eventService.getList(
                page,
                pageSize,
                search
            );

            if (response.success) {

                setEvents(response.data.items);

                setTotalPages(response.data.totalPages);

            }

        }
        catch (error) {

            console.log(error);

        }
        finally {

            setLoading(false);

        }

    };
    const handleDelete = async (id) => {

        const confirmed = await sweetAlert.confirmDelete();

        if (!confirmed) {

            return;

        }

        try {

            const response = await eventService.delete(id);

            if (response.success) {

                toast.success(response.message);

                loadEvent();

            }
            else {

                toast.error(response.message);

            }

        }
        catch (error) {

            console.log(error);

            toast.error("Something went wrong.");

        }

    };
    return (

        <AdminLayout>

            <div className="page-header">

                <h2>Event</h2>

                <Link
                    to="/events/add"
                    className="btn btn-primary"
                >
                    Add Event
                </Link>

            </div>
            <div className="d-flex mb-3 gap-2">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search Events..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />

                <button
                    className="btn btn-primary"
                    disabled={loading}
                    onClick={() => setPage(1)}
                >
                    Search
                </button>
            </div>
            <div className="card">

                <div className="card-body">

                    <table className="table table-bordered">

                        <thead>

                            <tr>
                                <th>Cover</th>
                                <th>Event Title</th>
                                <th>Event Date</th>
                                <th>Location</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>

                        </thead>

                        <tbody>

                            {
                                loading ?

                                    <tr>
                                        <td colSpan="6" className="text-center">
                                            Loading...
                                        </td>
                                    </tr>

                                    :

                                    events.length === 0 ?

                                        <tr>
                                            <td colSpan="6" className="text-center">
                                                No Events Found
                                            </td>
                                        </tr>

                                        :

                                        events.map(item => (

                                            <tr key={item.eventId}>

                                                <td style={{ width: "90px" }}>

                                                    {
                                                        item.coverImage ?

                                                            <img
                                                                src={`${process.env.REACT_APP_SERVER_URL}${item.coverImage}`}
                                                                alt={item.eventTitle}
                                                                className="img-thumbnail"
                                                                style={{
                                                                    width: "70px",
                                                                    height: "70px",
                                                                    objectFit: "cover"
                                                                }}
                                                            />

                                                            :

                                                            "-"
                                                    }

                                                </td>

                                                <td>
                                                    {item.eventTitle}
                                                </td>

                                                <td>
                                                    {
                                                        item.eventDate
                                                            ? new Date(item.eventDate).toLocaleDateString("en-IN")
                                                            : "-"
                                                    }
                                                </td>

                                                <td>
                                                    {item.location || "-"}
                                                </td>

                                                <td>

                                                    {
                                                        item.isActive

                                                            ? <span className="badge bg-success">Active</span>

                                                            : <span className="badge bg-danger">Inactive</span>
                                                    }

                                                </td>

                                                <td>

                                                    <Link
                                                        to={`/events/edit/${item.eventId}`}
                                                        className="btn btn-warning btn-sm me-2"
                                                    >
                                                        Edit
                                                    </Link>
                                                    <Link
                                                        to={`/events/${item.eventId}/gallery`}
                                                        className="btn btn-info btn-sm me-2"
                                                    >
                                                        Gallery
                                                    </Link>
                                                    <button
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => handleDelete(item.eventId)}
                                                    >
                                                        Delete
                                                    </button>

                                                </td>

                                            </tr>
                                        ))
                            }

                        </tbody>

                    </table>

                </div>

            </div>

        </AdminLayout>

    );

}